<template>
  <div class="check-list-person auto-list_col_centered">
    <div v-if="responseDriverFio">
      <p class="date">{{ shortFio(responseDriverFio) }}</p>
      <p
        v-if="allowActive"
        class="date status"
        @click.stop="$emit('open', 'driver')"
      >
        Изменить водителя
      </p>
    </div>
    <div v-else>
      <p
        v-if="allowActive"
        class="date status"
        @click.stop="$emit('open', 'driver')"
      >
        Выбрать водителя
      </p>
      <p v-else class="date">Нет данных</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShortFIO',
  props: {
    response: {
      type: Object,
      default: () => {},
    },
    allowActive: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      responseDriverFio: '',
    }
  },
  watch: {
    response: {
      handler(val) {
        this.responseDriverFio = val ? val.driver_name : 'Нет данных'
      },
      immediate: true,
    },
  },
}
</script>

<style scoped></style>
